import type dayjs from 'dayjs';
import { type PromoCodeSettings } from '../../../../api/types';

export { default as CreatePromoCodeFrom } from './CreatePromoCodeFrom';
export { default as EditPromoCodeForm } from './EditPromoCodeForm';
export { default as usePromoCodeFormValidator, useCreatePromoCodeFormValidator } from './usePromoCodeFormValidator';

export type PromoCodeFormValues = Omit<PromoCodeSettings, 'moduleVariants'> & {
    variantModuleIds: string[];
    // module variant mapping
    // as module id as the key and values are variant ids
    moduleVariantsMapping?: { [moduleId: string]: string[] };
    startTime: dayjs.Dayjs | null;
    endTime: dayjs.Dayjs | null;
};
export type { NewPromoCodeFormValues } from './CreatePromoCodeFrom';
